import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { CreditFacilityReceivablesDashboardRoute } from '~/borrower/routes/receivables/CreditFacilityReceivablesDashboardRoute';
import { useCreditFacilityContext } from '~/packages/credit-facility/hooks/CreditFacilityProvider';

// Exports
export const CreditFacilityReceivablesDashboardRouter = () => {
  const { creditFacilityId } = useCreditFacilityContext();
  return (
    <Routes>
      {/* Paths relative to "/credit-facility-receivables/*" */}
      <Route
        path="/:creditFacilityId"
        element={<CreditFacilityReceivablesDashboardRoute />}
      />
      <Route
        path="/*"
        element={
          <Navigate to={`/credit-facility-receivables/${creditFacilityId}`} />
        }
      />
    </Routes>
  );
};
